import React from 'react'
import { ExternalLink } from '@yleisradio/yds-icons-react'
import Notification from '../Notification/Notification'
import Button from '../Button/Button'

const ChoiceNotificationAd = () => {
  return (
    <div style={{ maxWidth: '36em', margin: '0 auto' }}>
      <Notification
        isMultiline
        level="warning"
        title="Huom! Tehtävän käyttö äänestyksiin ja visailuihin on lopetettu."
        variant="primary"
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
          Voit luoda äänestyksiä ja visailuja helposti Choice-työkalulla.
        </div>
        <div style={{ whiteSpace: 'nowrap', marginLeft: '1em' }}>
          <Button
            iconAfter={<ExternalLink />}
            onClick={() => window.open('https://interaction.yle.fi/admin/choice')}
            size="xs"
            text="Avaa Choice"
            variant="primary"
          />
        </div>
      </Notification>
    </div>
  )
}

export default ChoiceNotificationAd
